import React from 'react'

import LoopIcon from '@material-ui/icons/Loop'

import { ReactComponent as Warning } from './assets/alert-icon.svg'
import { ReactComponent as Error } from './assets/error-icon.svg'
import { ReactComponent as Success } from './assets/success-icon.svg'

export enum NotificationModalPalette {
  error = 'error',
  warning = 'warning',
  success = 'secondary',
  loading = 'loading',
}

interface ModalType {
  [key: string]: {
    imageModal: React.ReactNode
    borderColor: NotificationModalPalette
  }
}

export const ModalTypes: ModalType = {
  success: {
    imageModal: <Success />,
    borderColor: NotificationModalPalette.success,
  },
  warning: {
    imageModal: <Warning />,
    borderColor: NotificationModalPalette.warning,
  },
  error: {
    imageModal: <Error />,
    borderColor: NotificationModalPalette.error,
  },
  loading: {
    imageModal: <LoopIcon />,
    borderColor: NotificationModalPalette.loading,
  },
}
